export default {
    SET_LOCATIONS(state, data) {
        state.locations = data;
    },
};
